// Tipos compartidos del módulo pipeline-constructor.
// Espejos de los Schemas de apps/pipeline_constructor/routers.py

export interface ProjectDTO {
  id: number;
  source: string;
  external_id: string;
  title: string;
  project_type: string;
  amount_mxn: number | null;
  contractor_name: string;
  state: string;
  municipality: string;
  start_date: string | null;
  end_date: string | null;
  fuente_url: string | null;
}

export interface InventoryItemDTO {
  id: number;
  name: string;
  category: string;
  daily_rate_mxn: number | null;
  is_active: boolean;
}

export interface ScoreBreakdown {
  inventory_match?: number;
  geo_fit?: number;
  urgency?: number;
  weights?: { inventory?: number; geo?: number; urgency?: number };
}

export interface LeadDTO {
  id: number;
  score: number;
  score_breakdown: ScoreBreakdown;
  status: string;
  matched_inventory_count: number;
  project: ProjectDTO;
  created_at: string;
}

export interface LeadDetailDTO extends LeadDTO {
  matched_inventory: InventoryItemDTO[];
  outreach_log: Array<{
    ts: string;
    channel: string;
    action?: string;
    template?: string;
    reason?: string;
    response?: string;
  }>;
}

export interface CoverageZoneDTO {
  id: number;
  state: string;
  municipalities: string[];
  priority: number;
}

export interface RunDTO {
  id: string;
  status: string;
  started_at: string | null;
  completed_at: string | null;
  projects_discovered: number;
  leads_created: number;
  error_message: string;
}

export interface TriggerRunResult {
  run_id: string;
  status: string;
  raw_rows: number;
  new_projects: number;
  leads: number;
}

export interface LeadFilters {
  status?: string;
  project_type?: string;
  state?: string;
  min_score?: number;
}

export const LEAD_STATUSES = [
  { value: 'new', label: 'Nuevo' },
  { value: 'scored', label: 'Scoreado' },
  { value: 'outreach_queued', label: 'Outreach pendiente' },
  { value: 'outreach_sent', label: 'Outreach enviado' },
  { value: 'responded', label: 'Respondido' },
  { value: 'handed_off', label: 'Handoff a CRM' },
  { value: 'dismissed', label: 'Descartado' },
] as const;

export const PROJECT_TYPES = [
  { value: 'infraestructura', label: 'Infraestructura' },
  { value: 'vertical_residencial', label: 'Vertical residencial' },
  { value: 'vertical_comercial', label: 'Vertical comercial' },
  { value: 'industrial', label: 'Industrial' },
  { value: 'urbanizacion', label: 'Urbanización' },
  { value: 'publica', label: 'Obra pública' },
  { value: 'mineria', label: 'Minería' },
  { value: 'otro', label: 'Otro' },
] as const;
